import React, { useState, useEffect } from "react";
import './styles.css';
import { alert_error, alert_success } from './AppContext';
import AdModal from './app_structure/AdModal';
import AdSense from 'react-adsense';
import { Link, useLocation } from 'react-router-dom';
import { Cookies } from './index.js';
import { Helmet } from "react-helmet";
import StatusBadge from "./js/buttonstatus.jsx";
import { ClipLoader } from 'react-spinners';
import axios from "axios";
import queryString from 'query-string';
import ToggleButton from './app_structure/toggleButton';
import Banner from './Banner';
import Bannerprofile from './shop/ads/Bannerprofile.jsx';
import Coin_seller_cancel from './wallet/e_commerce/coin_seller_cancel.jsx';
import Videos_maker_continue from './kiemtien/socialmedia/videos_maker/continue.jsx';
import Language_i18 from './js/useNationalLanguage.jsx';
import Accounts_product from './order/account/orders/services/accounts_product.jsx';

function Nhatkyorders({ category_main }) {
  const { i18n, lang } = Language_i18();
  const translations = {
    vi: {
      confirm: "Xác nhận",
      processing: "Vui lòng đợi một lát 😊",
      enterInfo: "Vui lòng điền đầy đủ thông tin",
      copySuccess: "Đã sao chép",
      noData: "Không tìm thấy dữ liệu",
      emptyList: "Danh sách đơn hàng trống rỗng, chưa có thông tin nào",
      list: "Danh sách",
      search: "Tìm kiếm",
      searchMode: "Chọn 1 chế độ tìm kiếm",
      searchByLink: "Tìm theo liên kết",
      searchById: "Tìm theo id",
      searchPlaceholder: "Điền từ khóa",
      orderCode: "mã đơn hàng",
      service: "DỊCH VỤ",
      link: "link",
      description: "Mô tả",
      time: "THỜI GIAN",
      start: "Bắt đầu",
      remaining: "còn lại",
      amount: "Số lượng",
      money: "Coins",
      note_old: "Mã đơn check gửi support khi lỗi",
    },
    en: {
      confirm: "Confirm",
      processing: "Please wait a moment 😊",
      enterInfo: "Please enter all information",
      copySuccess: "Copied",
      noData: "No data found",
      emptyList: "Order list is empty, no information available",
      list: "List",
      search: "Search",
      searchMode: "Select a search mode",
      searchByLink: "Search by link",
      searchById: "Search by ID",
      searchPlaceholder: "Enter keyword",
      orderCode: "Order Code",
      service: "SERVICE",
      link: "Link",
      description: "Description",
      time: "TIME",
      start: "Start",
      remaining: "Remaining",
      amount: "Amount",
      money: "Coins",
      note_old: "Order code to send to support when there’s an error",
    }
  };

  const [isProcessing, setIsProcessing] = useState(0);
  const [showList, setShowList] = useState(true);
  const currentPath = window.location.pathname;
  const parts = currentPath.split('/');
  const endpoint = parts[parts.length - 1];

  const [buttonText, setButtonText] = useState(translations[lang]?.confirm);
  const [isSearching, setIsSearching] = useState(false);
  const [searchInput, setSearchInput] = useState('');
  const [searchMode, setSearchMode] = useState('');
  const options = [
    { text: translations[lang]?.searchMode, value: '' },
    { text: translations[lang]?.searchByLink, value: 'getlienket' },
    { text: translations[lang]?.searchById, value: 'getid' }
  ];

  const copyToClipboard = (value) => {
    alert_success(translations[lang]?.copySuccess);
    window.saochepnative(value);
  };

  const handleToggle = (isOn) => {
    if (isOn) {
      setIsSearching(true);
    } else {
      setIsSearching(false);
      setShowList(true);
    }
  };

  const handleSearchResponse = (response) => {
    if (response.data !== '') {
      setIsProcessing(0);
      setButtonText(translations[lang]?.confirm);
      setOrderData(response.data);
      setIsLoadingList(false);
      setIsSearching(false);
      setShowList(false);
    } else {
      setIsProcessing(0);
      setButtonText(translations[lang]?.confirm);
      alert_error(translations[lang]?.noData);
    }
  };

  const handleSubmit = (event) => {
    const apikey = Cookies.get('apikey');
    event.preventDefault();
    setIsProcessing(1);
    setButtonText(translations[lang]?.processing);
    if (!searchInput || !searchMode) {
      alert(translations[lang]?.enterInfo);
      setIsProcessing(0);
      setButtonText(translations[lang]?.enterInfo);
      return;
    } else {
      axios.get(`https://hust.media/getservice/${endpoint}.php?${searchMode}=${searchInput}&apikey=${apikey}`)
        .then(response => handleSearchResponse(response))
        .catch(error => console.log(error));
    }
  };

  const [isLoadingList, setIsLoadingList] = useState(true);
  const totalPages = 8;
  const values = queryString.parse(window.location.search);
  const currentPageFromQuery = values.listtrang || 1;
  const [currentPage, setCurrentPage] = useState(1);
  const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

  const [orderData, setOrderData] = useState([
    {
      id: 1,
      start_count: 100,
      remains: 50,
      service_name: translations[lang === 'vi' ? 'vi' : 'en'].emptyList.split(' ')[0] + " " + translations[lang === 'vi' ? 'vi' : 'en'].processing.split(' ')[0],
      url: translations[lang === 'vi' ? 'vi' : 'en'].emptyList.split(' ')[0] + " " + translations[lang === 'vi' ? 'vi' : 'en'].processing.split(' ')[0],
      amount: 10,
      money: 100,
      note: "Note 1",
      updatedate: "2023-04-05",
    }
  ]);

  const fetchOrderHistory = async () => {
    const apikey = Cookies.get('apikey');
    const listtrang = values.listtrang || 1;
    setCurrentPage(values.listtrang);
    try {
      const response = await axios.get(`https://hust.media/getservice/${endpoint}.php`, {
        params: {
          listtrang: listtrang,
          apikey: apikey,
          category_main: category_main
        }
      });
      if (response.data !== '') {
        setOrderData(response.data);
        setIsLoadingList(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const location = useLocation();
  useEffect(() => {
    setIsLoadingList(true);
    console.log('Đã thay đổi đường dẫn:', location.pathname);
    fetchOrderHistory();
  }, [location]);

  const [showAd, setShowAd] = useState(true);
  const handleCloseAd = () => setShowAd(false);

  return (
    <>
      <Banner />
      {endpoint === 'checkvar' ? (
        <AdSense.Google
          client="ca-pub-4574266110812955"
          slot="3259681051"
          style={{ display: 'block' }}
          format="auto"
          responsive="true"
        />
      ) : (
        <>
          {(endpoint === 'cash_diary' || endpoint === 'nhatkyaccount' || endpoint === 'accounts_history') ? (
            <>
              <AdModal isOpen={showAd} onClose={handleCloseAd} />
              <div className="mt-1 max-w-md mx-auto">
                <Bannerprofile chedo="fullviews" />
              </div>
            </>
          ) : (
            <>
              {endpoint === 'nhatkyorders' ? (
                <>
                  <div className="max-h-16">
                    <div className="cards">
                      <AdSense.Google
                        client="ca-pub-4574266110812955"
                        slot="1627514116"
                        style={{ display: 'block' }}
                        format="horizontal"
                        responsive="false"
                      />
                    </div>
                  </div>
                  <div className="mt-1 max-w-md mx-auto">
                    <Bannerprofile chedo="qualityviews" />
                  </div>
                </>
              ) : (
                <div className="max-h-16">
                  <div className="cards">
                    <AdSense.Google
                      client="ca-pub-4574266110812955"
                      slot="1627514116"
                      style={{ display: 'block' }}
                      format="horizontal"
                      responsive="false"
                    />
                  </div>
                </div>
              )}
            </>
          )}
        </>
      )}

      <div className="mb-2" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        {translations[lang]?.list} <ToggleButton onToggle={handleToggle} isOnload="no" /> {translations[lang]?.search}
      </div>

      {isSearching ? (
        <form className="add-form">
          <div className="form-control">
            <select
              id="countries2"
              className="selectpicker sp1 form-control"
              onChange={(e) => setSearchMode(e.target.value)}
            >
              {options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.text}
                </option>
              ))}
            </select>
            <label>{translations[lang]?.searchPlaceholder}</label>
            <br />
            <div className="input-group flex-nowrap">
              <span className="input-group-text" id="addon-wrapping">
                Search
              </span>
              <input
                type="text"
                className="form-control"
                placeholder={translations[lang]?.searchPlaceholder}
                aria-label="inputlienket"
                value={searchInput}
                name="inputlienket"
                aria-describedby="addon-wrapping"
                onChange={e => setSearchInput(e.target.value)}
              />
            </div>
          </div>
          <br />
          <button
            onClick={handleSubmit}
            className="flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-3 w-full dark:bg-slate-800 dark:text-white"
          >
            <div className="flex items-center justify-between flex-1">
              {isProcessing === 1 && (
                <div className="spinner-border" role="status"></div>
              )}
              <span className="text-lg font-medium text-white">{buttonText}</span>
              <div className="text-xl">{'\u27A4'}</div>
            </div>
          </button>
        </form>
      ) : (
        <>
          {showList && (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <nav>
                <ul className="pagination flex gap-0">
                  {pageNumbers.map((pageNumber) => (
                    <li key={pageNumber} className={`page-item ${pageNumber === currentPage ? 'active' : ''}`}>
                      <Link
                        to={
                          (endpoint === 'cash_diary' || endpoint === 'nhatkyaccount' || endpoint === 'accounts_history')
                            ? `?listtrang=${pageNumber}`
                            : `/reactapp/${endpoint}?listtrang=${pageNumber}`
                        }
                        className="page-link px-2 py-1 text-sm"
                      >
                        {pageNumber}
                      </Link>

                    </li>
                  ))}
                </ul>
              </nav>
            </div>
          )}

          <div className="container-fluid mt--9">
            <div className="row">
              <div className="col-xl-12 order-xl-2 mb-5 mb-xl-0">
                {orderData === 'empty' && !isLoadingList ? (
                  <div className="table-responsive overflow-x-hidden">
                    <div className="text-center text-2xl mt-3">
                      📦 {translations[lang]?.emptyList} 📭
                    </div>
                  </div>
                ) : (
                  isLoadingList ? (
                    <div style={{ textAlign: "center" }} className="mt-4 justify-center items-center">
                      <ClipLoader color="#fff" size={150} />
                    </div>
                  ) : (
                    <div className="table-responsive overflow-x-hidden">
                      <table className="table align-middle table-flush table-sm table-bordered">
                        <thead className="thead-light">
                          <tr>
                            <th className="text-lowercase text-center" style={{ width: "10%" }} scope="row">
                              {translations[lang]?.orderCode}
                            </th>
                            <th className="text-center" style={{ width: "10%" }} scope="row">
                              {translations[lang]?.service}
                            </th>
                            {(endpoint === 'nhatkyaccount' || endpoint === 'accounts_history') ? (
                              <th className="text-lowercase text-center" style={{ width: "33%" }} scope="col">
                                {translations[lang]?.link}
                              </th>
                            ) : (
                              <th className="text-lowercase text-center" style={{ width: "15%" }} scope="col">
                                {translations[lang]?.link}
                              </th>
                            )}
                            <th className="text-center" style={{ width: "10%" }} scope="row">
                              {translations[lang]?.description}
                            </th>
                            <th className="text-center" style={{ width: "10%" }} scope="col">
                              {translations[lang]?.time}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {orderData.map((item, index) => (
                            <tr key={index}>
                              <td className="text-center">
                                <p onClick={() => copyToClipboard(item.id)} className="text-sm">{item.id}</p>
                                <b>{translations[lang]?.start}</b>
                                <br />
                                {item.start_count}
                                <br />
                                {translations[lang]?.remaining}
                                <br />
                                <span className="badge badge-default">
                                  <b className="text-black">{item.remains}</b>
                                </span>
                              </td>
                              <td className="text-center">
                                <span className="inline-block text-sm font-bold text-white px-1 py-1 break-all bg-violet-500 rounded-pill text-wrap">
                                  <b className="text-white">{item.service_name}</b>
                                </span>
                              </td>
                              {(endpoint === 'nhatkyaccount') ? (
                                <td className="text-center">
                                  <div style={{ width: "100%" }} className="inline-block bg-blue-500 font-bold text-white px-2 py-1 rounded-full break-all text-wrap">
                                    <div className="text-base">{item.url}</div>
                                  </div>
                                </td>
                              ) : endpoint === 'accounts_history' ? (
                                <td className="text-center">
                                  <Accounts_product accounts_product={JSON.parse(item.url)} />
                                  thông tin shop
                                  <div className="text-base">
                                    Tên tk: {item.api_url}, id tk: {item.api_key}, nhắn tin:{" "}
                                    <a
                                      href={item.link_shop}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="text-blue-500 underline"
                                    >
                                      {item.link_shop}
                                    </a>
                                  </div>
                                </td>
                              ) : (
                                <td className="text-center">
                                  <div onClick={() => copyToClipboard(item.url)} style={{ width: "100%" }} className="inline-block bg-danger font-bold text-white px-2 py-1 rounded-full break-all text-wrap">
                                    <div className="text-base">{item.url}</div>
                                  </div>
                                  {item.identifier && (
                                    <div onClick={() => copyToClipboard(item.url)} style={{ width: "100%" }} className="mt-1 inline-block bg-orange-400 font-bold text-white px-2 py-1 rounded-full break-all text-wrap">
                                      <div className="text-xs">{item.identifier}</div>
                                    </div>
                                  )}
                                </td>
                              )}
                              <td className="text-center">
                                <b style={{ color: "blue" }}>{item.amount}</b>
                                <br />
                                <b style={{ color: "red" }}>{item.money}</b> {translations[lang]?.money}
                                <br />
                                <div style={{ width: "100%" }} className="text-wrap">
                                  <StatusBadge status={item.status} />
                                </div>
                              </td>
                              <td className="text-center">
                                <div style={{ width: "100%" }} className="text-wrap">
                                  {item.createdate}
                                  <br />
                                  {endpoint === 'nhatkyaccount' ? (
                                    <div
                                      onClick={() => copyToClipboard(item.note)}
                                      className="inline-block bg-blue-500 font-bold text-white px-1 py-1 rounded-full break-all text-wrap"
                                    >
                                      <div className="text-base">
                                        {translations[lang]?.note_old} {item.note}
                                      </div>
                                    </div>
                                  ) : endpoint === 'accounts_history' ? (
                                    <div
                                      className="text-xs text-lowercase text-black badge-light break-all font-bold rounded-pill text-wrap"
                                      dangerouslySetInnerHTML={{ __html: item.note }}
                                    ></div>
                                  ) : (
                                    <div
                                      className="text-xs text-lowercase text-black badge-light break-all font-bold rounded-pill text-wrap"
                                      dangerouslySetInnerHTML={{ __html: item.note }}
                                    ></div>
                                  )}

                                  {endpoint !== 'cash_diary' ? (
                                    <><br /> {item.updatedate}</>
                                  ) : (
                                    <>
                                      {item.category_code !== 'e_commerce' ? (
                                        <> {item.updatedate}</>
                                      ) : (
                                        <Coin_seller_cancel id_seller_orders={item.id} />
                                      )}
                                    </>
                                  )}
                                  {item.category_code === 'videos_maker' && <Videos_maker_continue id_seller_orders={item.id} />}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Nhatkyorders;